<template>
    <framework>
        <template #side>
            <!--Main Outline-->
            <div class="menu"
                 :class="{'no-scroll': inAnimation, 'minimized': sidePanel.minimized || sidePanel.submenu, 'details': sidePanel.details}"
            >
                <h1>
                    <span>my</span>247ed.com
                </h1>

                <ul v-if="enrollment && (outlineId || sectionId)" :class="{'hide-details': !sidePanel.details}">
                    <router-link :to="{name: 'course-welcome', params: {enrollmentId: enrollment.id}}" custom v-slot="{ navigate, isActive }" active-class="active">
                        <li @click="navigate" :class="{'active': isActive}" class="has-text-weight-bold" style="font-size: 1rem; padding-top: 1rem; padding-bottom: 1rem;">
                            <b-tooltip label="Return to Course Information" position="is-right" append-to-body type="is-light" size="is-large">
                                <i class="fad fa-fw fa-angles-left" :style="{'color': colors.primary}"></i>
                            </b-tooltip><span class="nav-title">Return to Course Information</span>
                            <div class="meta"></div>
                        </li>
                    </router-link>

                    <template v-for="(o, index) in enrollment.course.navigation.outline">
                        <template v-if="o.type === 'SECTION'">

                            <b-collapse
                                animation="slide"
                                :open="enrollment.course.navigation.currentSection === index"
                                @open="enrollment.course.navigation.currentSection = index"
                            >
                                <template #trigger="props">
                                    <li class="sub-header">
                                        <div class="columns is-gapless">
                                            <div class="column sub-header-title">
                                                {{ o.title }}
                                            </div>
                                            <div class="column is-narrow has-text-right">
                                                <i class="fas fa-fw dropdown-icon" :class="[(props.open) ? 'fa-angle-up' : 'fa-angle-down']"></i>
                                            </div>
                                        </div>
                                    </li>
                                </template>

                                <!-- SECTION CHILDREN -->
                                <template v-for="z in o.children">
                                    <li class="sub-header" v-if="z.type === 'HEADER'">{{ z.title }}</li>

                                    <!-- OVERVIEW-->
                                    <template v-if="z.type === 'OVERVIEW'">
                                        <router-link
                                            :to="{name: 'overview', params: {sectionId: z.id}}"
                                            custom v-slot="{ navigate, isActive }"
                                            active-class="active"
                                        >
                                            <li
                                                @click="navigate"
                                                :class="{'active': isActive}"
                                                :style="{'background-color': (isActive) ? colors.primary + ' !important' : 'white'}"
                                            >
                                                <div class="columns is-gapless">
                                                    <div class="column is-narrow">
                                                        <i class="fad fa-fw fa-circle-info" :style="{'color': colors.primary}"></i>
                                                    </div>
                                                    <div class="column component-title">Overview</div>
                                                </div>
                                            </li>
                                        </router-link>
                                    </template>

                                    <!-- COMPONENT -->
                                    <template v-else-if="z.type === 'COMPONENT'">
                                        <li
                                            v-if="z.closed"
                                            @click="contentAlert"
                                            style="background-color: white"
                                        >
                                            <div class="columns is-gapless">
                                                <div class="column is-narrow">
                                                    <i class="fa-fw" :class="z.icon" :style="{'color': colors.primary}"></i>
                                                </div>
                                                <div class="column component-title">{{ z.title }}</div>
                                            </div>
                                        </li>
                                        <router-link
                                            v-else
                                            :to="{name: 'component', params: {enrollmentId: enrollment.id, outlineId: z.id}}"
                                            custom v-slot="{ navigate, isActive }"
                                            active-class="active"
                                        >
                                            <li
                                                @click="navigate"
                                                :class="{'active': isActive}"
                                                :style="{'background-color': (isActive) ? colors.primary + ' !important' : 'white'}"
                                            >
                                                <div class="columns is-gapless">
                                                    <div class="column is-narrow">
                                                        <i
                                                            class="fa-fw"
                                                            :class="z.icon"
                                                            :style="{'color': colors.primary}"
                                                        ></i>
                                                    </div>
                                                    <div class="column component-title">{{ z.title }}</div>
                                                </div>
                                            </li>
                                        </router-link>
                                    </template>
                                </template>
                            </b-collapse>
                        </template>
                    </template>

                </ul>
            </div>

            <!-- Course tools pinned above the collapse controls -->
            <div class="course-tools" :class="{'minimized': sidePanel.minimized || sidePanel.submenu}">
                <ul>
                    <li @click="showNotePanel = true">
                        <i class="fad fa-fw fa-memo-pad" :style="{'color': colors.primary}"></i>
                        <span class="component-title">New Note</span>
                    </li>
                    <li @click="showUploadPanel = true">
                        <i class="fad fa-fw fa-cloud-arrow-up" :style="{'color': colors.primary}"></i>
                        <span class="component-title">Upload File</span>
                    </li>
                </ul>
            </div>

            <div class="controls ">
                <div class="columns is-gapless">
                    <div class="column has-text-right">
<!--                    <span @click="toggleDetails()" v-if="!sidePanel.minimized && !sidePanel.submenu"><i class="fad mt-2 mr-3" :class="{'fa-bars': sidePanel.details, 'fa-diagram-cells': !sidePanel.details}"></i></span>-->
                    <span @click="minimize(false)" v-if="sidePanel.minimized && !sidePanel.submenu"><i class="fad fa-chevrons-right mt-2"></i></span>
                    <span @click="minimize(true)" v-if="!sidePanel.submenu"><i class="fad fa-chevrons-left mt-2"></i></span>
                    </div>
                </div>
            </div>
        </template>

        <template #main>

            <template v-if="enrollment">
                <main-header no-border :title="enrollment.course.title" icon="fa-chalkboard-teacher" close="Close Course" :closeRoute="{name: 'course-welcome'}"/>
                <router-view @update="reloadEnrollment()"/>
            </template>
            <div class="content mt-6" v-else>
                <h3 class="has-text-white"><i class="fas fa-spinner fa-spin mr-4"></i>Please wait. Loading content...</h3>
            </div>

            <!-- Course tools drawers (shared with the Notes and Files pages) -->
            <note-editor-panel
                :is-open="showNotePanel"
                :enrollment-id="enrollmentId"
                @close="showNotePanel = false"
            />
            <file-upload-panel
                :is-open="showUploadPanel"
                :enrollment-id="enrollmentId"
                :is-stem="isStem"
                @close="showUploadPanel = false"
                @uploaded="showUploadPanel = false"
            />
        </template>
    </framework>
</template>

<script>
    import Framework from "../../components/framework/Framework";
    import MainHeader from "../../components/framework/MainHeader";

    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {client as http, apiUrl} from "../../http_client";
    import CourseHeader from "../../components/course/CourseHeader";
    import moment from "moment";
    import UiCard from "../../components/UiCard";
    import RenderBlocks from "../../components/course/RenderBlocks";
    import CourseSideNav from "../../components/course/CourseSideNav.vue";
    import NoteEditorPanel from "../../components/course/NoteEditorPanel";
    import FileUploadPanel from "../../components/course/FileUploadPanel";

    export default {
        components: {CourseSideNav, RenderBlocks, UiCard, CourseHeader, Framework, MainHeader, NoteEditorPanel, FileUploadPanel},
        props: ['enrollmentId', 'outlineId', 'sectionId'],
        data: function() {
            return {
                loading: true,
                menuOpen: 0,
                inAnimation: false,
                showNotePanel: false,
                showUploadPanel: false,
                apiUrl
            };
        },
        computed: {
            ...mapGetters(['colors', 'enrollment', 'sidePanel']),
            // Same rule the files API applies server-side
            isStem() {
                return this.enrollment?.setup_data?.stem_agreed === true;
            },
            isExpired() {
                const e = this.enrollment;
                if (!e || !e.expires_on || e.completed_at) return false;
                return new Date(e.expires_on) < new Date(new Date().toDateString());
            }
        },
        methods: {
            ...mapActions(['getEnrollmentById']),
            loadEnrollment: function() {
                if (!this.enrollment || this.enrollment.id !== parseInt(this.enrollmentId)) {
                    this.getEnrollmentById(this.enrollmentId).then((enroll) => {
                        console.log('[Outline] Enrollment loaded:', enroll.id, enroll.course?.title);
                        this.loading = false;
                        if (this.blockIfExpired()) return;
                        this.redirect();
                        this.openActiveSection();
                    }).catch(err => {
                        console.log('[Outline] Error loading enrollment:', err);
                    });
                } else {
                    this.loading = false;
                    if (this.blockIfExpired()) return;
                    this.redirect();
                    this.openActiveSection();
                }

                // this.setColors({
                //     primary: this.enrollment.course.organization.primary_color,
                //     background1: this.enrollment.course.organization.background_color_1,
                //     background2: this.enrollment.course.organization.background_color_2,
                // });

            },
            // Expired enrollments can't enter the lesson viewer — send them back
            // to Course Information, where the reactivation card is
            blockIfExpired() {
                if (!this.isExpired) return false;
                this.$router.replace({name: 'course-welcome', params: {enrollmentId: this.enrollmentId}});
                return true;
            },
            reloadEnrollment() {
                // This is used to reload the enrollment after a component completed, a bit lazy to do this
                this.getEnrollmentById(this.enrollmentId).then((enroll) => {
                    this.loading = false;
                }).catch(err => {
                    console.log(err);
                });
            },
            redirect: function() {
                // Completed/finished coursework still routes into the viewer —
                // View.vue renders it read-only with the locked notice
                const currentItemId = this.outlineId;
                if (!this.sectionId && !currentItemId) {
                    if (this.enrollment.last_component) {
                        console.log('Going to last component');
                        this.$router.push({name: 'component', params: {enrollmentId: this.enrollment.id, outlineId: this.enrollment.last_component}});
                    } else {
                        if (this.enrollment.course.navigation.outline[0].children[0].type === 'OVERVIEW') {
                            console.log('Going to start, overview', this.enrollment.course.navigation.outline[0].children[0]);
                            this.$router.push({name: 'overview', params: {enrollmentId: this.enrollment.id, sectionId: this.enrollment.course.navigation.outline[0].children[0].id}});
                        } else {
                            console.log('Going to start, component', this.enrollment.course.navigation.outline[0].children[0]);
                            this.$router.push({name: 'component', params: {enrollmentId: this.enrollment.id, outlineId: this.enrollment.course.navigation.outline[0].children[0].id}});
                        }
                    }
                }
            },
            openActiveSection: function() {
                const currentItemId = this.outlineId;
                console.log('openActiveSection', parseInt(currentItemId));

                for (let i = 0; i < this.enrollment.course.navigation.outline.length; i++) {
                    const o = this.enrollment.course.navigation.outline[i];
                    if (o.type === 'SECTION') {
                        for (let j = 0; j < o.children.length; j++) {
                            const component = o.children[j];

                            if (component.id === parseInt(currentItemId)) {
                                console.log('-- Found it seeking to section ' + i);
                                this.enrollment.course.navigation.currentSection = i;
                                break
                            }
                        }
                    }
                }
            },
            contentAlert: function() {
                this.$buefy.toast.open({
                    message: 'This content is not available until you complete previous content.',
                    type: 'is-danger',
                    duration: 5000,
                    position: 'is-top-right'
                });
            },
            toggleDetails: function() {
                this.$store.commit('setDetails', !this.sidePanel.details);
            },
            minimize: function(state) {
                this.$store.commit('setMinimized', state);
            }
        },
        watch: {
            outlineId: function() {
                if (this.outlineId) {
                    console.log('Outline changed... seeking menu', this.outlineId);
                    this.openActiveSection();
                }
            },
            sectionId: function() {
                if (this.sectionId) {
                    console.log('Section changed... seeking menu', this.sectionId);
                    for (let i = 0; i < this.enrollment.course.navigation.outline.length; i++) {
                        const o = this.enrollment.course.navigation.outline[i];
                        if (o.type_id === this.sectionId) {
                            // this.inAnimation = true;
                            this.menuOpen = i;
                        }
                    }
                }
            },
            menuOpen: function() {
                // try to smooth out animation and hide scrollbar
                // this.inAnimation = true;
                // setTimeout(() => {
                //     this.inAnimation = false
                // }, 1000);
            }
        },
        mounted() {
            this.loadEnrollment();
        }
    };
</script>

<style lang="scss" scoped>
    .course-frame {
        top: 100px;
        left: 5rem;
        right: 4rem;
        bottom: 1rem;
    }

    .menu {
        position: absolute;
        top: 0;
        bottom: 121px; // collapse controls (32px) + pinned course tools
        left: 0;
        right: 0;
        overflow-y: auto;

        background-color: #fff;
        background-image: linear-gradient(white, #eeeeee);

        &.no-scroll {
            overflow-y: hidden;
        }

        &.complete {
            bottom: 120px !important;
        }

        h1 {
            font-weight: 400;
            font-size: 30px;
            margin-top: 1rem;
            display: inline-block;
            cursor: pointer;
            padding: 1rem 1.5rem 0;
            color: #4a4a4a;
            letter-spacing: -1px;

            span {
                font-weight: 900;
                margin-right: 3px;

                color: #336699;

                &.beta {
                    color: #333;
                    border: 1px solid #c2c2c2;
                    border-radius: 3px;
                    padding: 0 4px;
                    font-size: 0.6rem;
                    margin-left: 0.5rem;
                    vertical-align: super;
                    font-weight: normal;
                    letter-spacing: normal;
                }
            }
        }

        ul {
            margin-top: 16px;
            margin-bottom: 10rem;
            border-top: 1px dashed #e0e2e8;

            li {
                border-bottom: 1px solid #e0e2e8;
                padding: 0.9rem 1.4rem 0.6rem;
                font-size: 0.9rem;
                color: #4a4a4a;
                transition: all 200ms;
                cursor: pointer;
                background-color: rgba(255, 255, 255, 0.5);

                &.active {
                    background-color: #336699 !important;

                    color: white;

                    .meta, i {
                        color: white !important;
                    }
                }

                &.sub-header {
                    font-weight: bold !important;
                    color: #4a4a4a !important;
                    padding: 1rem 1.2rem 0.8rem 1.2rem !important;
                    font-size: 0.9rem !important;
                    //text-transform: uppercase;
                    background-color: #e3e3e3 !important;
                    cursor: pointer;
                    border-bottom: 1px solid #ffffff;

                    i.dropdown-icon {
                        font-size: 12px;
                        color: #343434;
                        padding: 0;
                        margin: 0;
                    }

                    &:hover {
                        background-color: #cccccc !important;
                        color: white;

                        .meta, i {
                            color: white !important;
                        }
                    }
                }

                &:hover {
                    background-color: #919191 !important;
                    color: white;

                    .meta, i {
                        color: white !important;
                    }
                }

                i {
                    color: #3c6691;
                    font-size: 1.5rem;
                    vertical-align: middle;
                    margin-right: 1.2rem;
                    transition: all 200ms;
                }

                .meta {
                    transition: color 200ms;

                    font-weight: normal;
                    font-size: 0.8rem;
                    padding-left: 3.15rem;
                    color: #737881;
                    line-height: 1rem;
                }
            }

            &.hide-details {
                li {
                    font-size: 0.9rem;
                    font-weight: normal;
                    padding: 0.8rem 1.4rem;

                    .meta {
                        display: none;
                    }

                    i {
                        font-size: 1.2rem;
                        margin-right: 0.8rem;
                    }
                }
            }
        }

        &.minimized {
            overflow: hidden;

            h1 {
                display: none;
            }

            ul {
                padding-top: 4.7rem;

                li {
                    padding: 1rem 1.1rem;

                    i {
                        font-size: 1.3rem;
                    }

                    .nav-title, .meta, .component-title, .sub-header-title {
                        display: none;
                    }

                    .dropdown-icon {
                        font-size: 1.3rem !important;
                        color: #686868 !important;
                    }

                    //&.sub-header {
                    //    display: none;
                    //}
                }
            }
        }
    }

    .complete {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 1px solid #ccc;
        background-color: white;
        padding: 1.5rem 1rem;
        overflow: hidden;
        height: 120px;

        i {
            font-size: 1.2rem;
            vertical-align: middle;
        }
    }

    .controls {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 1px solid #ccc;
        background-color: #ddd;
        padding: 0 1.5rem;
        height: 32px;
        overflow: hidden;
        color: #214367;

        span {
            cursor: pointer;
        }
    }

    // Note/upload shortcuts pinned to the bottom of the outline column
    .course-tools {
        position: absolute;
        bottom: 32px; // sits directly on the collapse controls bar
        left: 0;
        right: 0;
        background-color: #fff;
        border-top: 1px solid #ccc;

        ul li {
            padding: 0.75rem 1.4rem;
            font-size: 0.9rem;
            color: #4a4a4a;
            cursor: pointer;
            border-bottom: 1px solid #e0e2e8;
            transition: all 200ms;

            &:last-child {
                border-bottom: none;
            }

            i {
                color: #3c6691;
                font-size: 1.2rem;
                vertical-align: middle;
                margin-right: 0.8rem;
                transition: all 200ms;
            }

            &:hover {
                background-color: #919191;
                color: white;

                i {
                    color: white !important;
                }
            }
        }

        &.minimized {
            ul li {
                padding: 0.75rem 1.1rem;

                .component-title {
                    display: none;
                }
            }
        }
    }

</style>

<style lang="scss">
    .vjs-big-play-button {
        top: 47% !important;
        left: 46.5% !important;
    }
</style>
